import React from "react";
import {
    Table,
    TableRow,
    TableCell,
    TableHead,
    TableBody,
    TableCellProps,
    Skeleton,
    Typography,
    TableContainer,
} from "@mui/material";

type Props = {
    headers: Array<{
        props?: TableCellProps;
        name: React.ReactNode;
    }>;
    rows?: Array<
        {
            props?: TableCellProps;
            ele: JSX.Element | string | number;
        }[]
    >;
    isLoading?: boolean;
    limit: number;
    consumeHeightOfOther?:number
};

const BasicTable = ({ headers, rows, isLoading, limit = 15,consumeHeightOfOther = 180 }: Props) => {
    const [usedSpaceOfHeight, setUsedSpaceOfHeight] = React.useState(0);
  
    React.useEffect(() => {
        // set height of table
        const heightOfElePaperHeader = document.getElementById("paper-action-head")?.offsetHeight || 0;
        const heightOfTabsheader = document.getElementById("tabs-header")?.offsetHeight || 0;
        setUsedSpaceOfHeight(consumeHeightOfOther + heightOfElePaperHeader + heightOfTabsheader);
    }, []);

    return (
        <>
            <TableContainer sx={{ height: `calc(100vh - ${usedSpaceOfHeight}px)` }}>
                <Table
                    stickyHeader
                    size="small"
                    sx={{
                        "& .basic__table__row": {
                            position: "sticky",
                            lineHeight: "23px",
                        },
                        "& .basic__table__row::after": {
                            content: "''",
                            width: "1px",
                            height: "65%",
                            bgcolor: "#CACDCF",
                            position: "absolute",
                            top: "50%",
                            right: 0,
                            transform: "translateY(-50%)",
                        },
                        "& tr .basic__table__row:last-child:after": {
                            display: "none",
                        },
                    }}
                >
                    <TableHead>
                        <TableRow sx={{}}>
                            {headers.map((head, index) => (
                                <TableCell
                                    key={index}
                                    className="basic__table__row font-16"
                                    {...head.props}
                                    sx={{
                                        py: 1.5,
                                        borderTop: "1px solid #CACDCF !important",
                                        borderBottom: "1px solid #CACDCF !important",
                                        bgcolor: "#EFF5F0",
                                        px: { md: 1, sx: 0.3 },
                                        ...head.props?.sx,
                                    }}
                                >
                                    {head.name}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!!isLoading
                            ? [...Array(limit)].map((e, index) => (
                                  <TableRow key={index}>
                                      {[...Array(headers.length)].map((item, i) => (
                                          <TableCell key={i} className="basic__table__row" sx={{ py: 2 }}>
                                              <Skeleton variant="text" />
                                          </TableCell>
                                      ))}
                                  </TableRow>
                              ))
                            : rows && (
                                  <>
                                      {rows.map((row, index) => (
                                          <TableRow key={index}>
                                              {row.map((item, i) => (
                                                  <TableCell
                                                      key={i}
                                                      className="basic__table__row font-16"
                                                      {...item.props}
                                                      sx={{ py: 1.5, px: { md: 1, sx: 0.3 },...item.props?.sx }}
                                                  >
                                                      {item.ele}
                                                  </TableCell>
                                              ))}
                                          </TableRow>
                                      ))}
                                  </>
                              )}

                        {!!(!rows?.length && !isLoading) && (
                            <TableRow>
                                <TableCell colSpan={headers.length} align="center">
                                    <Typography className="font-18" color="grey.500">
                                        ไม่พบข้อมูล
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default React.memo(BasicTable);
